// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

.library-item_library-item_zeYsO {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  flex-basis: 160px;
  position: relative;
  height: 160px;
  max-width: 160px;
  margin: 0.5rem;
  padding: 1rem 1rem 0 1rem;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  color: var(--text-primary);
  background: var(--ui-white);
  border-width: 2px;
  border-style: solid;
  border-color: var(--ui-black-transparent);
  border-radius: 0.5rem;
  text-align: center;
  cursor: pointer;
}

.library-item_library-item-extension_W93Or {
  align-self: stretch;
}

.library-item_library-item_zeYsO:hover {
  border-width: 2px;
  border-color: var(--looks-secondary);
}

.library-item_hidden_zFAij {
  display: none;
}

.library-item_disabled_MTakK {
  opacity: 0.5;
  cursor: auto;
}

.library-item_disabled_MTakK:hover {
  border-color: var(--ui-black-transparent);
}

.library-item_library-item-image-container-wrapper_KJLCv {
  height: 100px;
  width: 100%;
  position: relative;
}

.library-item_library-item-image-container_rKUCR {
  position: absolute;
  height: 100px;
  width: 100%;
}

.library-item_library-item-inset-image-container_aI9ii {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -2.5rem;
  align-self: flex-start;
  background-color: var(--pen-primary);
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 0.5rem;
  border: 0.25rem solid var(--ui-white);
}

[dir='ltr'] .library-item_library-item-inset-image-container_aI9ii {
  margin-left: 1rem;
}

[dir='rtl'] .library-item_library-item-inset-image-container_aI9ii {
  margin-right: 1rem;
}

.library-item_library-item-image__Wo7C {
  max-width: 100%;
  max-height: 100%;
}

.library-item_library-item-inset-image_MZ7BZ {
  width: 2.5rem;
}

.library-item_library-item-name_x5OTE {
  width: 80%;
  margin: 0.25rem 0;
  text-align: center;

  /*
        For truncating overflowing text gracefully
        Min-width is for a bug: https://css-tricks.com/flexbox-truncated-text
    */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.library-item_featured-item_tpTss {
  flex-basis: 300px;
  max-width: 300px;
  height: auto;
  overflow: hidden;
  padding: 0;
}

.library-item_featured-image-container_gOrB1 {
  position: relative;
  width: 100%;
}

.library-item_featured-image_TOp1L {
  width: 100%;
  aspect-ratio: 2;
}

.library-item_featured-text__aRQV {
  font-weight: bold;
  padding: 10px;
  /* height: 140px; */
  width: 300px;
}

[dir='ltr'] .library-item_featured-extension-text_x4q8u {
  text-align: left;
  padding-left: 1.25rem;
}

[dir='rtl'] .library-item_featured-extension-text_x4q8u {
  text-align: right;
  padding-right: 1.25rem;
}

.library-item_featured-description_rbqcP {
  display: block;
  font-weight: normal;
  line-height: 1.375rem;
  padding-top: 0.3125rem;
  padding-bottom: 0.25rem;
}

.library-item_featured-extension-metadata_LA0Wz {
  width: 100%;
  padding: 0 1.25rem 1rem 1.25rem;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  font-size: 12px;
  color: var(--text-primary);
  opacity: 0.75;
}

[dir='ltr'] .library-item_featured-extension-metadata_LA0Wz {
  text-align: left;
}

[dir='rtl'] .library-item_featured-extension-metadata_LA0Wz {
  text-align: right;
}

.library-item_featured-extension-requirement_cew5o {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.library-item_featured-extension-collaboration_CB1T5 {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.library-item_featured-extension-metadata-detail_zFfUG {
  height: 100%;
  padding-top: 0.4rem;
  font-weight: bold;
}

.library-item_featured-extension-metadata-detail_zFfUG img {
  margin-right: 0.25rem;
  width: 20px;
  height: 20px;
}

.library-item_extension-links_HyhYI {
  width: 300px;
  padding: 0 1.25rem 1rem 1.25rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  opacity: 0.75;
  text-align: left;
}

.library-item_extension-links_HyhYI a {
  color: inherit !important;
  text-decoration: underline;
}

.library-item_coming-soon-text_L_zfL {
  position: absolute;
  background-color: var(--data-primary);
  border-radius: 1rem;
  box-shadow: 0 0 0.5rem hsla(0, 0%, 0%, 0.25);
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: bold;
  color: var(--ui-white);
}

[dir='ltr'] .library-item_coming-soon-text_L_zfL {
  transform: translate(calc(2 * 0.5rem), calc(2 * 0.5rem));
}

[dir='rtl'] .library-item_coming-soon-text_L_zfL {
  transform: translate(calc(-2 * 0.5rem), calc(2 * 0.5rem));
}

.library-item_favorite-container_TieLd {
  display: none;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
}

.library-item_favorite-icon_QF8EY {
  width: 32px;
  height: 32px;
}

.library-item_favorite-container_TieLd.library-item_active_bozcD,
.library-item_library-item_zeYsO:hover .library-item_favorite-container_TieLd {
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/components/library-item/library-item.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,2DAA2D;EAC3D,0BAA0B;EAC1B,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,oCAAoC;EACpC,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;;EAElB;;;KAGG;EACH,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,4CAA4C;EAC5C,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,cAAc;AAChB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n.library-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  flex-basis: 160px;\n  position: relative;\n  height: 160px;\n  max-width: 160px;\n  margin: 0.5rem;\n  padding: 1rem 1rem 0 1rem;\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  color: var(--text-primary);\n  background: var(--ui-white);\n  border-width: 2px;\n  border-style: solid;\n  border-color: var(--ui-black-transparent);\n  border-radius: 0.5rem;\n  text-align: center;\n  cursor: pointer;\n}\n\n.library-item-extension {\n  align-self: stretch;\n}\n\n.library-item:hover {\n  border-width: 2px;\n  border-color: var(--looks-secondary);\n}\n\n.hidden {\n  display: none;\n}\n\n.disabled {\n  opacity: 0.5;\n  cursor: auto;\n}\n\n.disabled:hover {\n  border-color: var(--ui-black-transparent);\n}\n\n.library-item-image-container-wrapper {\n  height: 100px;\n  width: 100%;\n  position: relative;\n}\n\n.library-item-image-container {\n  position: absolute;\n  height: 100px;\n  width: 100%;\n}\n\n.library-item-inset-image-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: -2.5rem;\n  align-self: flex-start;\n  background-color: var(--pen-primary);\n  width: 3.5rem;\n  height: 3.5rem;\n  border-radius: 0.5rem;\n  border: 0.25rem solid var(--ui-white);\n}\n\n[dir='ltr'] .library-item-inset-image-container {\n  margin-left: 1rem;\n}\n\n[dir='rtl'] .library-item-inset-image-container {\n  margin-right: 1rem;\n}\n\n.library-item-image {\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.library-item-inset-image {\n  width: 2.5rem;\n}\n\n.library-item-name {\n  width: 80%;\n  margin: 0.25rem 0;\n  text-align: center;\n\n  /*\n        For truncating overflowing text gracefully\n        Min-width is for a bug: https://css-tricks.com/flexbox-truncated-text\n    */\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n}\n\n.featured-item {\n  flex-basis: 300px;\n  max-width: 300px;\n  height: auto;\n  overflow: hidden;\n  padding: 0;\n}\n\n.featured-image-container {\n  position: relative;\n  width: 100%;\n}\n\n.featured-image {\n  width: 100%;\n  aspect-ratio: 2;\n}\n\n.featured-text {\n  font-weight: bold;\n  padding: 10px;\n  /* height: 140px; */\n  width: 300px;\n}\n\n[dir='ltr'] .featured-extension-text {\n  text-align: left;\n  padding-left: 1.25rem;\n}\n\n[dir='rtl'] .featured-extension-text {\n  text-align: right;\n  padding-right: 1.25rem;\n}\n\n.featured-description {\n  display: block;\n  font-weight: normal;\n  line-height: 1.375rem;\n  padding-top: 0.3125rem;\n  padding-bottom: 0.25rem;\n}\n\n.featured-extension-metadata {\n  width: 100%;\n  padding: 0 1.25rem 1rem 1.25rem;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  font-size: 12px;\n  color: var(--text-primary);\n  opacity: 0.75;\n}\n\n[dir='ltr'] .featured-extension-metadata {\n  text-align: left;\n}\n\n[dir='rtl'] .featured-extension-metadata {\n  text-align: right;\n}\n\n.featured-extension-requirement {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.featured-extension-collaboration {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.featured-extension-metadata-detail {\n  height: 100%;\n  padding-top: 0.4rem;\n  font-weight: bold;\n}\n\n.featured-extension-metadata-detail img {\n  margin-right: 0.25rem;\n  width: 20px;\n  height: 20px;\n}\n\n.extension-links {\n  width: 300px;\n  padding: 0 1.25rem 1rem 1.25rem;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  opacity: 0.75;\n  text-align: left;\n}\n\n.extension-links a {\n  color: inherit !important;\n  text-decoration: underline;\n}\n\n.coming-soon-text {\n  position: absolute;\n  background-color: var(--data-primary);\n  border-radius: 1rem;\n  box-shadow: 0 0 0.5rem hsla(0, 0%, 0%, 0.25);\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  font-weight: bold;\n  color: var(--ui-white);\n}\n\n[dir='ltr'] .coming-soon-text {\n  transform: translate(calc(2 * 0.5rem), calc(2 * 0.5rem));\n}\n\n[dir='rtl'] .coming-soon-text {\n  transform: translate(calc(-2 * 0.5rem), calc(2 * 0.5rem));\n}\n\n.favorite-container {\n  display: none;\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  position: absolute;\n  top: 0.5rem;\n  left: 0.5rem;\n}\n\n.favorite-icon {\n  width: 32px;\n  height: 32px;\n}\n\n.favorite-container.active,\n.library-item:hover .favorite-container {\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"library-item": `library-item_library-item_zeYsO`,
	"libraryItem": `library-item_library-item_zeYsO`,
	"library-item-extension": `library-item_library-item-extension_W93Or`,
	"libraryItemExtension": `library-item_library-item-extension_W93Or`,
	"hidden": `library-item_hidden_zFAij`,
	"disabled": `library-item_disabled_MTakK`,
	"library-item-image-container-wrapper": `library-item_library-item-image-container-wrapper_KJLCv`,
	"libraryItemImageContainerWrapper": `library-item_library-item-image-container-wrapper_KJLCv`,
	"library-item-image-container": `library-item_library-item-image-container_rKUCR`,
	"libraryItemImageContainer": `library-item_library-item-image-container_rKUCR`,
	"library-item-inset-image-container": `library-item_library-item-inset-image-container_aI9ii`,
	"libraryItemInsetImageContainer": `library-item_library-item-inset-image-container_aI9ii`,
	"library-item-image": `library-item_library-item-image__Wo7C`,
	"libraryItemImage": `library-item_library-item-image__Wo7C`,
	"library-item-inset-image": `library-item_library-item-inset-image_MZ7BZ`,
	"libraryItemInsetImage": `library-item_library-item-inset-image_MZ7BZ`,
	"library-item-name": `library-item_library-item-name_x5OTE`,
	"libraryItemName": `library-item_library-item-name_x5OTE`,
	"featured-item": `library-item_featured-item_tpTss`,
	"featuredItem": `library-item_featured-item_tpTss`,
	"featured-image-container": `library-item_featured-image-container_gOrB1`,
	"featuredImageContainer": `library-item_featured-image-container_gOrB1`,
	"featured-image": `library-item_featured-image_TOp1L`,
	"featuredImage": `library-item_featured-image_TOp1L`,
	"featured-text": `library-item_featured-text__aRQV`,
	"featuredText": `library-item_featured-text__aRQV`,
	"featured-extension-text": `library-item_featured-extension-text_x4q8u`,
	"featuredExtensionText": `library-item_featured-extension-text_x4q8u`,
	"featured-description": `library-item_featured-description_rbqcP`,
	"featuredDescription": `library-item_featured-description_rbqcP`,
	"featured-extension-metadata": `library-item_featured-extension-metadata_LA0Wz`,
	"featuredExtensionMetadata": `library-item_featured-extension-metadata_LA0Wz`,
	"featured-extension-requirement": `library-item_featured-extension-requirement_cew5o`,
	"featuredExtensionRequirement": `library-item_featured-extension-requirement_cew5o`,
	"featured-extension-collaboration": `library-item_featured-extension-collaboration_CB1T5`,
	"featuredExtensionCollaboration": `library-item_featured-extension-collaboration_CB1T5`,
	"featured-extension-metadata-detail": `library-item_featured-extension-metadata-detail_zFfUG`,
	"featuredExtensionMetadataDetail": `library-item_featured-extension-metadata-detail_zFfUG`,
	"extension-links": `library-item_extension-links_HyhYI`,
	"extensionLinks": `library-item_extension-links_HyhYI`,
	"coming-soon-text": `library-item_coming-soon-text_L_zfL`,
	"comingSoonText": `library-item_coming-soon-text_L_zfL`,
	"favorite-container": `library-item_favorite-container_TieLd`,
	"favoriteContainer": `library-item_favorite-container_TieLd`,
	"favorite-icon": `library-item_favorite-icon_QF8EY`,
	"favoriteIcon": `library-item_favorite-icon_QF8EY`,
	"active": `library-item_active_bozcD`
};
export default ___CSS_LOADER_EXPORT___;
